"use strict";

require("core-js/modules/es6.array.filter");

require("core-js/modules/es6.object.define-property");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _objectSpread2 = _interopRequireDefault(require("@babel/runtime/helpers/objectSpread"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var _convert = require("./convert26");

var _map = _interopRequireDefault(require("unmutable/lib/map"));

var _size = _interopRequireDefault(require("unmutable/lib/size"));

var _set = _interopRequireDefault(require("unmutable/lib/set"));

var _take = _interopRequireDefault(require("unmutable/lib/take"));

var _toArray = _interopRequireDefault(require("unmutable/lib/toArray"));

var _update = _interopRequireDefault(require("unmutable/lib/update"));

var _isIndexed = _interopRequireDefault(require("unmutable/lib/util/isIndexed"));

var _pipe = _interopRequireDefault(require("unmutable/lib/util/pipe"));

var _pipeWith = _interopRequireDefault(require("unmutable/lib/util/pipeWith"));

function toStringKey(num) {
  return "#".concat((0, _convert.toString26)(num));
}

function isKey(str) {
  return str ? str[0] === "#" : false;
}

function toIntKey(str) {
  // $FlowFixMe - isKey() prevents .slice() from being called on null
  return isKey(str) ? (0, _convert.toInt26)(str.slice(1)) : undefined;
}

var _default = function _default() {
  var existingChild = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  return function (parcelData) {
    var value = parcelData.value,
        child = parcelData.child;

    if (!child) {
      return parcelData;
    }

    if (!(0, _isIndexed["default"])(value)) {
      var _updateChild = (0, _map["default"])(function (node, key) {
        return (0, _set["default"])('key', key)(node);
      });

      return (0, _pipeWith["default"])(parcelData, (0, _update["default"])('child', _updateChild));
    }

    var keys = (0, _pipeWith["default"])([].concat((0, _toConsumableArray2["default"])((0, _toArray["default"])()(child)), (0, _toConsumableArray2["default"])((0, _toArray["default"])()(existingChild))), (0, _map["default"])(function (_ref) {
      var key = _ref.key;
      return toIntKey(key);
    }));
    var highest = Math.max.apply(Math, [0].concat((0, _toConsumableArray2["default"])(keys.filter(Boolean))));
    var updateChild = (0, _pipe["default"])((0, _take["default"])((0, _size["default"])()(value)), (0, _map["default"])(function (_ref2) {
      var key = _ref2.key,
          node = (0, _objectWithoutProperties2["default"])(_ref2, ["key"]);
      return (0, _objectSpread2["default"])({
        key: isKey(key) ? key : toStringKey(++highest)
      }, node);
    }));
    return (0, _pipeWith["default"])(parcelData, (0, _update["default"])('child', updateChild));
  };
};

exports["default"] = _default;